import api from '@app/api'

import type { ResponseDto } from '@app/api/dtos'
import type { CreateMonitoringScheduleDto, MonitoringSchedulesListsDto } from './dtos'
import type {
  ChangeMonitoringScheduleData,
  CopyScheduleData,
  DeleteMonitoringScheduleData,
  GetMonitoringScheduleParams
} from './types'

const URL = '/monitoring-schedules/'

export const getMonitoringSchedulesLists = async (
  params?: GetMonitoringScheduleParams
): Promise<ResponseDto<MonitoringSchedulesListsDto>> => {
  const response = await api.get<ResponseDto<MonitoringSchedulesListsDto>>(URL, { params })
  return response.data
}

export const createMonitoringSchedule = async (data: CreateMonitoringScheduleDto): Promise<void> => {
  await api.post(URL, data)
}

export const editMonitoringSchedule = async ({ id, data }: ChangeMonitoringScheduleData): Promise<void> => {
  await api.patch(`${URL}${id}/`, data)
}

export const deleteMonitoringSchedule = async (data: DeleteMonitoringScheduleData): Promise<void> => {
  await api.delete(`${URL}`, { data })
}

export const copyMonitoringSchedule = async (data: CopyScheduleData): Promise<void> => {
  await api.post(`${URL}copy/`, data)
}
